module.exports = __webpack_public_path__ + "media/top-image.59a5e498.mp4";